import moment from 'moment'
import { currencyFormatter } from './ClaimsLineItemUtils'

export const ClaimLineItemColumnConfig = [
  {
    field: 'lineItemId',
    cellRenderer: 'agGroupCellRenderer',
    headerName: '',
    width: 15,
    resizable: false,
  },
  {
    field: 'dos',
    headerName: 'DOS Start/End',
    cellRenderer: (params: any) => {
      return (
        <>
          {params.data.dateOfServiceStart || params.data.dateOfServiceEnd ? (
            <>
              {params.data.dateOfServiceStart ? moment(params.data.dateOfServiceStart).format('MM/DD/YYYY') : '---'}
              <br />
              {params.data.dateOfServiceEnd ? moment(params.data.dateOfServiceEnd).format('MM/DD/YYYY') : '---'}
            </>
          ) : null}
        </>
      )
    },
  },
  {
    field: 'serviceCode',
    headerName: 'Service',
    sortable: true,
  },
  {
    field: 'placeOfService',
    headerName: 'POS',
    sortable: true,
  },

  {
    field: 'units',
    headerName: 'Units',
    sortable: true,
  },
  {
    field: 'serviceBilledAmount',
    headerName: 'Billed',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'allowedCoveredAmount',
    headerName: 'Allowed',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'discount',
    headerName: 'Adjustment',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'disallowedNotCoveredAmount',
    headerName: 'Disallowed',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'paidAmount',
    headerName: 'Paid',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'deductible',
    headerName: 'Deductible',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'coInsurance',
    headerName: 'Coins',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'copay',
    headerName: 'Copay',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'patientBalance',
    headerName: 'Patient Balance',
    valueFormatter: currencyFormatter,
    sortable: true,
  },
  {
    field: 'remarksData',
    headerName: 'Remarks',
    hide: true,
  },
]
